import { useTranslation } from "react-i18next";
import { Chip } from "@outpave/ds";
import type { ChipTone } from "@outpave/ds";

export type TransactionDirection = "DEPOSIT" | "WITHDRAWAL" | "UNKNOWN";

interface RenderTransactionDirectionProps {
  direction: TransactionDirection;
}

/**
 * Direction is a fact, not a verdict: a withdrawal is every ordinary card
 * purchase, so it stays `neutral` rather than reading as a failure. Only the
 * inflow is tinted, and only `UNKNOWN` warns, because that one means the
 * amount and the type disagreed.
 */
const TONE: Record<TransactionDirection, ChipTone> = {
  DEPOSIT: "positive",
  WITHDRAWAL: "neutral",
  UNKNOWN: "warning",
};

const LABEL: Record<TransactionDirection, string> = {
  DEPOSIT: "Deposit",
  WITHDRAWAL: "Withdrawal",
  UNKNOWN: "Unknown",
};

export const RenderTransactionDirection: React.FC<
  RenderTransactionDirectionProps
> = ({ direction }) => {
  const { t } = useTranslation();

  return (
    <Chip size="sm" tone={TONE[direction]} dot>
      {t(LABEL[direction])}
    </Chip>
  );
};
